import { Store } from '../core/store';
import { deriveClaims, type Claims, type Role, type User } from '../models/user';
import { api, PANEL_API } from './api-client';

export interface SessionState {
  /** null = giriş yok; bootstrapping sürerken loading=true */
  user: User | null;
  claims: Claims | null;
  loading: boolean;
}

export const session = new Store<SessionState>({ user: null, claims: null, loading: true });

interface MeResponse {
  user: User;
}

class AuthService {
  /** Açılışta mevcut cookie ile oturumu dene. */
  async bootstrap(): Promise<void> {
    try {
      const res = await api.get<MeResponse>(`${PANEL_API}/me`);
      this.accept(res.user);
    } catch {
      session.set({ user: null, claims: null, loading: false });
    }
  }

  async login(username: string, password: string): Promise<void> {
    const res = await api.post<MeResponse>(`${PANEL_API}/login`, { username, password });
    this.accept(res.user);
  }

  async logout(): Promise<void> {
    try {
      await api.post(`${PANEL_API}/logout`);
    } finally {
      session.set({ user: null, claims: null, loading: false });
    }
  }

  role(): Role | null {
    return session.get().user?.role ?? null;
  }

  claims(): Claims | null {
    return session.get().claims;
  }

  private accept(user: User): void {
    session.set({ user, claims: deriveClaims(user.role), loading: false });
  }
}

export const auth = new AuthService();
